module.exports = __webpack_public_path__ + "static/img/deer_logo_svg.88ec511.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deer_logo_svg.svg
// module id = 362
// module chunks = 2